import { render } from "./recentCompanies.vue?vue&type=template&id=2d9639e2"
import script from "./recentCompanies.vue?vue&type=script&lang=js"
export * from "./recentCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__